import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import { fontSize, fontWeight, lineHeight } from "../../constants/typography";
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import GridContainer from "../grid-container";
import { Headline } from "../typography";
import { ImageWithLazyAttributes } from "../images";
export var Container = styled(GridContainer).withConfig({
  componentId: "sc-1lilqse-0"
})(["justify-items:center;text-align:center;padding:64px 0;"]);
export var Quote = styled(Headline).withConfig({
  componentId: "sc-1lilqse-1"
})(["grid-column:1 / -1;margin-bottom:40px;", ";&::before{content:'\u201C';}&::after{content:'\u201D';}", ";", ";"], mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0, 0)), fontWeight.regular, fontSize.x2Large, lineHeight.xSmall), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 2 / -2;\n  "]))))), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 3 / -3;\n  "]))))));
export var Picture = styled(ImageWithLazyAttributes).withConfig({
  componentId: "sc-1lilqse-2"
})(["grid-column:1 / -1;width:56px;height:56px;border-radius:50%;margin-bottom:16px;", ";"], mediaQueries.sm(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 80px;\n    height: 80px;\n  "]))))));
export var FullName = styled.span.withConfig({
  componentId: "sc-1lilqse-3"
})(["grid-column:1 / -1;font-weight:", ";font-size:", ";line-height:", ";"], fontWeight.bold, fontSize.small, lineHeight.large);
export var JobTitle = styled.span.withConfig({
  componentId: "sc-1lilqse-4"
})(["grid-column:1 / -1;font-weight:", ";font-size:", ";line-height:", ";"], fontWeight.regular, fontSize.small, lineHeight.large);